module.exports = __webpack_public_path__ + "static/img/ARAS800_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAS800_1.png
// module id = eWh2
// module chunks = 0